import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.overlay = document.getElementById('sidebar-overlay')
    document.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  toggle() {
    this.panelTarget.classList.toggle('-translate-x-full')
    this.overlay.classList.toggle('hidden')
    document.body.classList.toggle('overflow-hidden')
  }

  close() {
    this.panelTarget.classList.add('-translate-x-full')
    this.overlay.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      this.close()
    }
  }
}
